<template>
  <b-table striped :items="items" :fields="[ useclosedat ? 'closed_at' : 'created_at', 'author', 'notes', 'id']">
      <template #head(id)>Actions</template>
      <template #cell(created_at)="data">{{ data.value | moment('Do MMM YYYY HH:mm') }}</template>
      <template #cell(closed_at)="data">{{ data.value | moment('Do MMM YYYY HH:mm') }}</template>
      <template #cell(notes)="data">
        <div>
          <b>{{ data.item.key.replace('|', ', ') }}</b>&nbsp;
          <code>{{ data.item.topic }}</code>
        </div>
        <blockquote class="blockquote" v-text="data.value"/>
      </template>
      <template #cell(id)="data">
        <b-button-group>
          <b-button :to="`/alerts/${data.item.topic}/${data.item.key}`" variant="primary">Notification</b-button>
          <b-button :to="`/alerts/${data.item.topic}/${data.item.key}/investigate`">Case</b-button>
        </b-button-group>
      </template>
    </b-table>
</template>

<script>
export default {
  props: ['items', 'useclosedat'],
};
</script>
